//#region src/discount_type.ts
var DiscountType = /* @__PURE__ */ function(DiscountType) {
	DiscountType[DiscountType["Percent"] = 1] = "Percent";
	DiscountType[DiscountType["Fixed"] = 2] = "Fixed";
	return DiscountType;
}(DiscountType || {});
//#endregion
export { DiscountType };

//# sourceMappingURL=discount_type.js.map